<div class="history-panel" [class.is-expanded]="isExpanded">
  <h3 class="history-title">{{ 'chat_history' | translate }}</h3>
  <ds-search-bar
    [fullKeyword]="'search_chats' | translate"
    [allowEmptySearch]="true"
    (search)="onSearch($event)"
    data-test-id="chat-history-search"
  ></ds-search-bar>

  @if (isLoading) {
    <div class="history-loading" aria-live="polite">
      {{ 'loading' | translate }}
    </div>
  } @else if (sessions.length === 0) {
    <div class="history-empty">
      {{ (currentSearch ? 'no_chat_history_search_results' : 'no_chat_history') | translate }}
    </div>
  } @else {
    <ul class="history-list" role="list">
      @if (hasPinned) {
        <li class="history-section-header" role="presentation">{{ 'chat_history_pinned' | translate }}</li>
        <ng-container *ngTemplateOutlet="sessionList; context: { sessions: pinnedSessions }"></ng-container>
        @if (unpinnedSessions.length > 0) {
          <li class="history-section-header" role="presentation">{{ 'chat_history_all_chats' | translate }}</li>
          <ng-container *ngTemplateOutlet="sessionList; context: { sessions: unpinnedSessions }"></ng-container>
        }
      } @else {
        <ng-container *ngTemplateOutlet="sessionList; context: { sessions }"></ng-container>
      }
    </ul>
    <ds-pagination
      #pagination
      [page]="currentPage"
      [pageSize]="PAGE_SIZE"
      [collectionSize]="totalSessions"
      [resultsName]="isExpanded ? 'chats' : ''"
      (pageChange)="onPageChange($event)"
      data-test-id="chat-history-pagination"
    ></ds-pagination>
  }
</div>

<ng-template #sessionList let-sessions="sessions">
  @for (session of sessions; track session.sessionId) {
    <li class="history-item" role="listitem" [class.is-selected]="session.sessionId === activeSessionId">
      <button
        #sessionButton
        class="history-item-content"
        type="button"
        [attr.aria-current]="session.sessionId === activeSessionId ? 'page' : null"
        (click)="onSelectSession(session)"
      >
        <span class="history-item-title">{{
          (session.title || ('untitled_chat' | translate)) + (session.titleTruncated ? '…' : '')
        }}</span>
        <span class="history-item-date">{{ session.lastActivity | date: 'mediumDate' }}</span>
      </button>
      <!--
        ds-dropdown's rendered toggle button always sets aria-labelledby (self-referencing) alongside
        aria-label, and aria-labelledby wins per the accname spec — so a plain [ariaLabel] here is
        silently discarded by JAWS/Chrome and the button ends up unnamed. Route the name through
        [ariaLabelledBy] instead, pointing at a visually-hidden span, so it actually wins.
        Text intentionally uses the full session.title, not the ellipsis-truncated visible text above.
      -->
      <span class="ds-visually-hidden" [id]="'chat-actions-label-' + session.sessionId">
        {{ 'chat_actions_for' | translate: session.title || ('untitled_chat' | translate) }}
      </span>
      <ds-dropdown #dropdown>
        <ds-dropdown-toggle
          [variant]="DsButtonVariants.microAction"
          [withChevron]="false"
          [icon]="Icons.EllipsisVertical"
          [buttonClass]="'chat-actions-toggle-btn'"
          [ariaLabelledBy]="'chat-actions-label-' + session.sessionId"
        ></ds-dropdown-toggle>
        <div ds-dropdown-menu>
          @if (session.isFavorite) {
            <ds-dropdown-item
              [label]="'action_unpin' | translate"
              [icon]="Icons.ThumbTack"
              (selected)="onPinSession(session)"
              data-test-id="pin-chat-session-menu-item"
            ></ds-dropdown-item>
          } @else {
            <ds-dropdown-item
              [label]="'action_pin' | translate"
              [icon]="Icons.ThumbTack"
              (selected)="onPinSession(session)"
              data-test-id="pin-chat-session-menu-item"
            ></ds-dropdown-item>
          }
          @if (isRenameEnabled) {
            <ds-dropdown-item
              [label]="'action_rename' | translate"
              [icon]="Icons.Pencil"
              (selected)="onRenameSession(session.sessionId, dropdown.dropdownToggleBtn?.elRef?.nativeElement)"
              data-test-id="rename-chat-session"
            ></ds-dropdown-item>
          }
          <ds-dropdown-item
            [label]="'action_delete' | translate"
            [icon]="Icons.TrashCan"
            [intent]="DsButtonIntent.destructive"
            (selected)="onDeleteSession(session.sessionId, dropdown.dropdownToggleBtn?.elRef?.nativeElement)"
            data-test-id="delete-chat-session"
          ></ds-dropdown-item>
        </div>
      </ds-dropdown>
    </li>
  }
</ng-template>
